import type { Stage } from '../../data/notationHotspots';
import { stageInfo, getHotspotsByStage } from '../../data/notationHotspots';
import './StageProgressBar.css';

interface StageProgressBarProps {
  currentStage: Stage;
  exploredByStage: Record<Stage, Set<string>>;
  onSelectStage: (stage: Stage) => void;
}

const progressStages: Stage[] = [1, 2, 3, 4];

export function StageProgressBar({ currentStage, exploredByStage, onSelectStage }: StageProgressBarProps) {
  return (
    <nav className="stage-progress">
      <div className="stage-progress__bar">
        {progressStages.map((stage, i) => {
          const info = stageInfo[stage];
          const isCurrent = currentStage === stage;
          const explored = exploredByStage[stage]?.size || 0;
          const total = getHotspotsByStage(stage).length;
          const canClick = !isCurrent;

          return (
            <div key={stage} className="stage-progress__step-wrapper">
              <button
                className={`stage-progress__step ${isCurrent ? 'stage-progress__step--current' : ''} ${canClick ? 'stage-progress__step--clickable' : ''}`}
                style={{ '--stage-color': info.color } as React.CSSProperties}
                onClick={() => canClick && onSelectStage(stage)}
                aria-current={isCurrent ? 'step' : undefined}
              >
                <div className="stage-progress__indicator">
                  <span>{stage}</span>
                </div>
                <div className="stage-progress__info">
                  <span className="stage-progress__label">{info.label}</span>
                  {total > 0 && (
                    <span className="stage-progress__count">{explored}/{total}</span>
                  )}
                </div>
              </button>
              {i < progressStages.length - 1 && (
                <div className="stage-progress__connector" />
              )}
            </div>
          );
        })}
      </div>

      {currentStage >= 1 && currentStage <= 3 && stageInfo[currentStage].uiLine && (
        <div className="stage-progress__ui-line" style={{ borderColor: stageInfo[currentStage].color }}>
          <i className="fas fa-quote-left" style={{ color: stageInfo[currentStage].color }}></i>
          <span>{stageInfo[currentStage].uiLine}</span>
        </div>
      )}
    </nav>
  );
}
